const ResultsCount = ({ total, t, currentPage }) => {
  const productsPerPage = 32;
  const start = (currentPage - 1) * productsPerPage + 1;
  const end = Math.min(currentPage * productsPerPage, total);

  return (
    <div className="flex gap-1 max-[991px]:text-sm">
      {t("Results")}
      <span className="text-red font-[600]">{start}</span>-
      <span className="text-red font-[600]">{end}</span>
      <span className=" font-[600]">{t("Of")}</span>
      <span className="text-red font-[600]">{total || ""}</span>
      {t("Products")}
    </div>
  );
};

export default ResultsCount;
